<template>
    <div class="page video-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}" :key="loading">
            <transition name="fade-transition">
                <Video v-if="videoData" :video="videoData.video" :meta="videoData.meta" :lecture="videoData.lecture" :video_views="videoData.video_views" :comments="videoData.comments" @loadMore="loadMore" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Video from './Video'

export default {
    name: "",
    components: {
        Video
    },
    data(){
        return {
            loading: false,
            videoData: null,
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        
    },
    methods: {
        ...GlobalMethods,
        loadData(page=null){
            if (!this.loading){
                this.loading = true;

                window.axios.get(`/videos/${this.id}${page ? '?page=' + page : ''}`).then(response=>{
                    this.videoData = response.data;
                    this.loading = false;
                    this.scrollToTop();
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        this.$router.push('/not-found')
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
        loadMore(page){
            this.loadData(page);
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>

</style>
